import {ZAHAV_ONLY_THRESHOLD_NIS} from '@sollapay/domain';
import {InfoNotice, Typography} from '@sollapay/ui/components';
import {formatNIS} from '@sollapay/utils';
import {useTranslation} from 'react-i18next';

const PREFIX = 'view.payouts.create.details.zahavOnlyNotice';

/** Explains why the transfer type is fixed to zahav once the amount reaches the zahav-only threshold. */
export function ZahavOnlyNotice() {
  const {t} = useTranslation('trustAccounts');

  return (
    <InfoNotice role="status">
      <Typography as="span" size="sm" weight="semibold">
        {t(`${PREFIX}.title`)}
      </Typography>{' '}
      {t(`${PREFIX}.body`, {threshold: formatNIS(ZAHAV_ONLY_THRESHOLD_NIS)})}
    </InfoNotice>
  );
}
